import React from 'react'
import DashboardMaster from '@/dashboard/DashboardMaster'
import AdminUser from './AdminUser'

const Users = () => {
  return (
    <DashboardMaster>
      <AdminUser />
    </DashboardMaster>
  )
}

export default Users